"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _withStyle = _interopRequireDefault(require("../utils/withStyle"));

var _excluded = ["origin"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NotifySuccess = function NotifySuccess(_ref) {
  var _ref$origin = _ref.origin,
      origin = _ref$origin === void 0 ? false : _ref$origin,
      props = _objectWithoutProperties(_ref, _excluded);

  if (origin) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-icon": "NotifySuccess"
    }, props), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.031 7.063C8.406 5.687 10.063 5 12 5c1.938 0 3.588.682 4.953 2.047C18.318 8.41 19 10.063 19 12c0 1.938-.682 3.588-2.047 4.953C15.59 18.318 13.938 19 12 19c-1.938 0-3.589-.682-4.953-2.047C5.682 15.59 5 13.938 5 12c0-1.938.677-3.583 2.031-4.938Z",
      fill: "#54EB91"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 9.762c.023-.025.035-.062.035-.112 0-.075-.012-.125-.035-.15l-1.069-.897c-.023-.025-.069-.037-.138-.037-.046 0-.08.012-.103.037l-3.862 4.78a864.018 864.018 0 0 1-1.552-1.607c-.07-.075-.138-.112-.207-.112-.023 0-.069.037-.138.112l-.897.972c-.023.025-.034.074-.034.15 0 .049.011.086.034.111l.07.038 2.724 2.84c.069.076.126.113.172.113.046 0 .103-.037.172-.112L16 9.762Z",
      fill: "#fff"
    }));
  }

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "data-icon": "NotifySuccess"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.031 7.063C8.406 5.687 10.063 5 12 5c1.938 0 3.588.682 4.953 2.047C18.318 8.41 19 10.063 19 12c0 1.938-.682 3.588-2.047 4.953C15.59 18.318 13.938 19 12 19c-1.938 0-3.589-.682-4.953-2.047C5.682 15.59 5 13.938 5 12c0-1.938.677-3.583 2.031-4.938Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.762c.023-.025.035-.062.035-.112 0-.075-.012-.125-.035-.15l-1.069-.897c-.023-.025-.069-.037-.138-.037-.046 0-.08.012-.103.037l-3.862 4.78a864.018 864.018 0 0 1-1.552-1.607c-.07-.075-.138-.112-.207-.112-.023 0-.069.037-.138.112l-.897.972c-.023.025-.034.074-.034.15 0 .049.011.086.034.111l.07.038 2.724 2.84c.069.076.126.113.172.113.046 0 .103-.037.172-.112L16 9.762Z"
  }));
};

var _default = (0, _withStyle["default"])(NotifySuccess);

exports["default"] = _default;